module.exports = __webpack_public_path__ + "media/marketo-modal/Left-46231acd.png";